import React from "react";
import { ChevronDown, User } from "lucide-react";

interface ProfileButtonProps {
  onClick: () => void;
  label: string;
  isMenuActive?: boolean;
}

const ProfileButton: React.FC<ProfileButtonProps> = ({
  onClick,
  label,
  isMenuActive,
}) => {
  return (
    <div
      onClick={onClick}
      role="button"
      className="bg-black cursor-pointer transition-all duration-300 hover:scale-[0.99] relative top-0 active:top-0.5 text-xs text-white flex flex-row items-center gap-x-2 border border-primary-1 rounded-lg py-1 sm:px-2.5 px-2"
    >
      <User className="text-primary-1 sm:h-5 h-4 sm:w-5 w-4" />
      <span className="font-extrabold font-redhat-display sm:block hidden">
        {label}
      </span>
      <ChevronDown
        className={`text-white h-4 w-4 ${isMenuActive ? "rotate-180" : "rotate-0"} transition-transform`}
      />
    </div>
  );
};

export default ProfileButton;
